import { ReminderType } from "components/todolist/Reminders/typing";

const reminderReducer = (state: ReminderType[], action: any): ReminderType[] => {
  switch (action.type) {
    case "set":
      return [...action.payload];
    case "add":
      return [...state, action.payload];
    case "remove":
      return state.filter((item) => item.id !== action.payload);
    case "update":
      return state.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload } : item
      );
    default:
      return state;
  }
};

export default reminderReducer;
